import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import AddIcon from '@material-ui/icons/Add';
import PlaylistAddIcon from '@material-ui/icons/PlaylistAdd';
import DeleteIcon from '@material-ui/icons/Delete';

import { TableEditBar, Modal, AppDatasetsModal } from './components';
import { DeleteModal } from 'components';
import Table from 'components/Table/Table';
import TableAction from 'components/Table/TableAction';
import DatasetDTO from 'dto/DatasetDTO';
import SharedRepoRecepientDTO from 'dto/SharedRepoRecepientDTO';
import ImportDatasetModal from './components/ImportDatasetModal';
import LibraryAddIcon from '@material-ui/icons/LibraryAdd';
import UpdateDatasetModal from './components/UpdateDataset';
import GetAppIcon from '@material-ui/icons/GetApp';
import VisibilityIcon from '@material-ui/icons/Visibility';
import repos from 'services/repositories'
import DataTableDialog from 'views/Repository/components/DataTableDialog';
import TableDownloadAction from 'components/Table/TableDownloadAction';

// Interface may be incomplete or incorrect
// Simply care about getting the table properly working
interface DatasetsProps {
  onAdd: (id: number) => (data: {toAdd?: DatasetDTO[],toRemove?: DatasetDTO[]}) => void,
  onAddDatasets: (id: number) => (data: {toAdd?: DatasetDTO[],toRemove?: DatasetDTO[]}, callback: () => void) => void
  repository: {
    id: number,
    datasets: DatasetDTO[]
  },
  handleRefresh: () => void,
  className: string,
  sharedRepos: SharedRepoRecepientDTO[]
}

const Datasets = (props: DatasetsProps) => {
  const { onAdd, onAddDatasets, repository, handleRefresh, sharedRepos, className, ...rest } = props;

  const [openDelete, setOpenDelete] = useState(false);
  const [openAdd, setOpenAdd] = useState(false);
  const [openAddDatasets, setOpenAddDatasets] = useState(false);
  const [openUpdate, setOpenUpdate] = useState(false);
  const [selectedDatasets, setSelectedDatasets] = useState([]);
  const [openDataset, setOpenDataset] = useState<DatasetDTO>();

  const [openImportDataset, setOpenImportDataset] = useState<boolean>(false);

  useEffect(() => {
    setSelectedDatasets([]);
  }, [repository.id])

  const handleDeleteModal = () => {
    const toRemove = repository.datasets.filter(el => selectedDatasets.includes(el.id))
    onAddDatasets(repository.id)({ toRemove }, () => {
      setOpenDelete(false);
      setSelectedDatasets([]); 
    });
  };

  const singleDataset = selectedDatasets[0] && repository.datasets.find(d => d.id === selectedDatasets[0]);

  return (
    <>
      <Table
        actions={<>
          <TableDownloadAction data={repository.datasets} fileName={'datasets.csv'} />
          <TableAction
            disabled={!sharedRepos.length}
            onClick={() => setOpenImportDataset(true)}
            title={!sharedRepos.length ? 'No datasets are shared with you':'Import Shared Datasets'}
          >
            <LibraryAddIcon/>
          </TableAction>
          <TableAction
            onClick={() => setOpenAddDatasets(true)}
            title='Import Rguroo Datasets'
          >
            <PlaylistAddIcon />
          </TableAction>
          <TableAction 
            onClick={() => setOpenAdd(true)}
            title="Upload Dataset"
          >
            <AddIcon />
          </TableAction>
        </>} 
        cellProps={{
          colCount: {align: 'center'},
          rowCount: {align: 'center'}
        }}
        classes={{root: className}}
        data={repository.datasets}
        filters={{
          name: {type: 'input'},
          title: {type: 'input'},
          description: {type: 'input'},
          rowCount: {type: 'numeric'},
          colCount: {type: 'numeric'}
        }}
        headerMap={{
          rowCount: 'Rows',
          colCount: 'Columns',
          description: 'Comment',
          fileExtension: 'File Type'
        }}
        headerProps={{
          colCount: {align: 'center'},
          rowCount: {align: 'center'}
        }}
        headers={['name', 'title', 'fileExtension', 'description', 'colCount', 'rowCount']}
        idKey='id'
        itemActions={[{
          Icon: <GetAppIcon/>,
          onClick: (r) => repos.downloadData(r),
          tooltip: 'Download data'
        }, {
          Icon: <VisibilityIcon/>,
          onClick: (r) => setOpenDataset(r),
          tooltip: 'Preview data'
        }]}
        selectable
        selectedIds={selectedDatasets}
        setSelectedIds={setSelectedDatasets}
        title='Datasets'
        {...rest}
      />
      <TableEditBar
        datasets={repository.datasets}
        handleRefresh={handleRefresh}
        onDelete={() => setOpenDelete(true)}
        onUpdate={() => setOpenUpdate(true)}
        selected={selectedDatasets}
      />
      <Modal
        onClose={() => setOpenAdd(false)}
        onSubmit={onAdd(repository.id)}
        open={openAdd}
      />
      <AppDatasetsModal
        onClose={() => setOpenAddDatasets(false)}
        onSubmit={onAddDatasets(repository.id)}
        open={openAddDatasets}
      />
      <DeleteModal
        buttonIcon={<DeleteIcon />}
        content="Are you sure you want to delete the selected dataset(s)?"
        onClose={() => setOpenDelete(false)}
        onDelete={handleDeleteModal}
        open={openDelete}
        title={`${selectedDatasets.length} Dataset(s)`}
      />
      <ImportDatasetModal
        onClose={() => {setOpenImportDataset(false); handleRefresh();}}
        open={openImportDataset}
        repositoryID={repository.id}
        sharedRepos={sharedRepos}
      />
      {singleDataset && <UpdateDatasetModal
        dataset={singleDataset}
        handleRefresh={handleRefresh}
        onClose={() => setOpenUpdate(false)}
        open={openUpdate}
        repositoryID={repository.id}
      />}
      <DataTableDialog
        dataset={openDataset}
        onClose={() => setOpenDataset(null)}
        open={!!openDataset} 
        title=''
      />
    </>
  );
};

Datasets.propTypes = {
  className: PropTypes.string,
  handleRefresh: PropTypes.func,
  onAdd: PropTypes.func,
  onAddDatasets: PropTypes.func,
  repository: PropTypes.object.isRequired,
  title: PropTypes.string
};

Datasets.defaultProps = {
  repository: {}
};

export default Datasets;
